import { datadogRum } from '@datadog/browser-rum';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { navPerformanceNow } from '~/utilities/navigationTiming';

export const TOGGLE_TYPE = {
  COSIGNER: 'cosigner',
  TRADEIN: 'tradein'
} as const;

export type ToggleType = (typeof TOGGLE_TYPE)[keyof typeof TOGGLE_TYPE];

export default function reportToggleComplete(
  toggleStartTime: number,
  toggleType: ToggleType
) {
  datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.TOGGLE_COMPLETE, {
    durationMs: navPerformanceNow() - toggleStartTime,
    toggleType
  });
}
